(function () {
    'use strict';

    angular.module('AngularAdmin')

        .factory('ProductionScheduleSvc', ['$http', function ($http) {
            var productionScheduleSvc = {
                getCalendarData: function (plant_id, year, month) {
                    var url = `/plant/${plant_id}/production_schedule/${year}/${month}/`;
                    return $http.get(url, {});
                },
                create: function (production_schedule_entry, plant_id) {
                    var url = String.format('/plant/{0}/production_schedule/new/', plant_id, production_schedule_entry.id);
                    return $http({
                        method: 'POST',
                        url: url,
                        data: production_schedule_entry
                    });
                },
                update: function (production_schedule_entry, plant_id) {
                    var url = String.format('/plant/{0}/production_schedule/{1}/', plant_id, production_schedule_entry.id);
                    return $http({
                        method: 'PUT',
                        url: url,
                        data: production_schedule_entry
                    })
                },
                get: function (production_schedule_entry_id, plant_id) {
                    var url = String.format('/plant/{0}/production_schedule/{1}/', plant_id, production_schedule_entry_id);
                    return $http.get(url, {});
                },
                delete: function (production_schedule_entry_id, plant_id) {
                    var url = String.format('/plant/{0}/production_schedule/{1}/delete/', plant_id, production_schedule_entry_id);
                    return $http({
                        method: 'DELETE',
                        url: url
                    });
                }
            };

            return productionScheduleSvc;
        }]);

})();